import { render, staticRenderFns } from "./patient_card_modification.vue?vue&type=template&id=4d63e812&scoped=true"
import script from "./patient_card_modification.vue?vue&type=script&lang=js"
export * from "./patient_card_modification.vue?vue&type=script&lang=js"
import style0 from "./patient_card_modification.vue?vue&type=style&index=0&id=4d63e812&prod&lang=scss&scoped=true"
import style1 from "./patient_card_modification.vue?vue&type=style&index=1&id=4d63e812&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d63e812",
  null
  
)

export default component.exports